<template>
  <span v-if="convertedBid > 0" class="converted-amount">{{ formatCurrency(convertedBid, "") }} {{ currency }}</span>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  const props = defineProps<{ amountProp: number | string }>();

  const auctionStore = useAuctionStore();

  const currencies = computed(() => {
    return auctionStore.currencies;
  });

  const currency = computed(() => {
    return auctionStore.currency;
  });

  const convertedBid = computed(() => {
    let rate = currencies.value.find((item) => item.abbr === currency.value.calue).rate;

    return rate ? props.amountProp * rate : "~";
  });
</script>
